import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { apiService } from '../services/api';
import ArticleCard from '../components/ArticleCard';
import SEO from '../components/SEO';
import AdBanner from '../components/AdBanner';
import AdComponent from '../components/AdComponent';
import HilltopBanner from '../components/HilltopBanner';

function HomePage() {
  const [articles, setArticles] = useState([]);
  const [calculators, setCalculators] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [articlesRes, calculatorsRes] = await Promise.all([
          apiService.getArticles(),
          apiService.getCalculators()
        ]);
        
        if (articlesRes.success) setArticles(articlesRes.data);
        if (calculatorsRes.success) setCalculators(calculatorsRes.data);
      } catch (error) {
        console.error('Error fetching data:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-orange-500 mx-auto"></div>
          <p className="mt-4 text-slate-600">Loading...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-orange-50 to-cyan-50">
          <SEO
              title="CalcBlog - Calculators & Insights"
              description="Your destination for helpful calculators and insightful articles. Making complex calculations simple and accessible."
              keywords="calcblog, online calculators, health calculators, bmi calculator, calorie calculator, sleep optimization calculator, carbon footprint calculator, monthly budget calculator, personal finance calculator, sustainability calculators, exosome skincare calculator, ai powered learning tools, interactive calculators, free online calculators, educational calculators, calculator blog, best calculators online, calculator for students, calculator for health, calculator for finance, calculator for environment"
              toolType="blog"
          />
      <div className="container mx-auto px-4 py-16">
        {/* Hero Section */}
        <section className="text-center mb-16">
          <h1 className="text-6xl font-bold text-slate-800 mb-6 dark:text-slate-100">
            Welcome to{' '}
            <span className="bg-gradient-to-r from-orange-500 to-cyan-500 bg-clip-text text-transparent dark:from-orange-400 dark:to-cyan-400">
              CalcBlog
            </span>
          </h1>
          <p className="text-2xl text-slate-600 max-w-3xl mx-auto leading-relaxed dark:text-slate-300">
            Discover helpful calculators and insightful articles for all your calculation needs.
          </p>
        </section>

        {/* Featured Calculators */}
        <section className="mb-16">
          <div className="flex justify-between items-center mb-8">
            <h2 className="text-4xl font-bold text-slate-800 dark:text-slate-300">Featured Calculators</h2>
            <Link to="/calculators" className="btn-primary">
              View All Calculators
            </Link>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {calculators.slice(0, 6).map(calculator => (
              <Link 
                key={calculator.id} 
                to={`/calculators/${calculator.slug}`}
                className="calculator-card text-center hover:shadow-xl transition-all duration-300 group"
              >
                <div className="w-20 h-20 bg-gradient-to-r from-orange-400 to-cyan-400 rounded-3xl flex items-center justify-center mx-auto mb-6 group-hover:scale-110 transition-transform duration-300 dark:text-slate-200 dark:group-hover:text-orange-400">
                  <span className="text-white text-2xl font-bold">∑</span>
                </div>
                <h3 className="text-2xl font-bold text-slate-800 mb-4 dark:text-slate-200">
                  {calculator.name}
                </h3>
                <p className="text-slate-600 dark:text-slate-400">
                  {calculator.description}
                </p>
              </Link>
            ))}
          </div>
        </section>
          <div className="h-64 w-full relative flex flex-col justify-center sm:pb-10">
            <div className="flex-1 grid grid-cols-1 md:grid-cols-2 p-4 ">
              <div className="hidden sm:block">
                <AdComponent /> 
              </div>
              <div> 
                <HilltopBanner /> 
              </div>  
            </div>    
           </div>  
            {/*
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4 justify-items-center my-6">
              <div className="w-full flex justify-start">
                <AdBanner adKey="857d3637cfc0b322e60f1c5c2a864a62" width={320} height={50} instanceId="ad1" />
              </div>

              
              <div className="w-full flex justify-start">
                <AdBanner adKey="857d3637cfc0b322e60f1c5c2a864a62" width={320} height={50} instanceId="ad2"/>
              </div>

              
              <div className="w-full flex justify-start">
                <AdBanner adKey="857d3637cfc0b322e60f1c5c2a864a62" width={320} height={50} instanceId="ad3"/>
              </div>
            </div>  
              */
             }
        
        {/* Latest Articles */}
        <section>
          <h2 className="text-4xl font-bold text-slate-800 mb-8 dark:text-slate-300">Latest Articles</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {articles.map(article => (
              <ArticleCard key={article.id} article={article} />
            ))}
          </div>
          
          {articles.length === 0 && (
            <div className="text-center py-12">
              <div className="text-slate-400 text-6xl mb-4">📝</div>
              <p className="text-slate-500 text-lg">No articles published yet.</p>
            </div>
          )}
        </section>
      </div>
    </div>
  );
}

export default HomePage;